import { styled } from '@material-ui/core/styles';

export const Wrapper = styled('nav')(({ theme: { breakpoints } }) => ({
  [breakpoints.down('sm')]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
}));
